import React, { useEffect, useState } from 'react'
import { Button, Image, Modal, Tabs, message } from 'antd'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import { getHouseDetailAPI } from '@/apis/house'
import { followHouse } from '@/apis/user'
import { checkMenu, getChildPath, checkLogin } from '@/utils'
import HouseInfo from './components/houseInfo'
import ActualSoldList from './components/actualSoldList'
import SignMonitor from './components/signMonitor'
import RoomList from './components/roomList'
import SoldChartList from './components/soldChartList'
import EvidenceList from './components/evidenceList'
import ProjectList from './components/projectList'
import BuildingList from './components/buildingList'
import RoomTypeList from './components/roomTypeList'
import Photo from './components/photo'

export default function Detail() {
  const [count, setCount] = useState(0)
  const [detailData, setDetailData] = useState({}) //  楼盘详情
  const [wxQrcode, setWxQrcode] = useState(false) // 微信码
  const [douyinQrcode, setDouyinQrcode] = useState(false) // 抖音码
  const [tabsKey, setTabsKey] = useState(0)
  const [tabsList, setTabsList] = useState([])
  const pageObj = {
    actualsoldlist: <ActualSoldList />,
    signmonitor: <SignMonitor />,
    roomList: <RoomList />,
    soldchartlist: <SoldChartList />,
    evidencelist: <EvidenceList />,
    projectlist: <ProjectList />,
    buildinglist: <BuildingList />,
    roomtypelist: <RoomTypeList />,
    photo: <Photo />
  }

  const location = useLocation()
  const navigate = useNavigate()
  const params = useParams()
  const id = params.id

  const toLinkTabs = url => {
    navigate(url)
    setCount(count + 1)
  }
  //  楼盘详情
  const getDetail = async () => {
    const res = await getHouseDetailAPI({ id })
    if (res.success === true) {
      setDetailData(res.result)
    }
  }
  const changeWxQrcode = () => {
    setWxQrcode(!wxQrcode)
  }
  const changeDouyinQrcode = () => {
    setDouyinQrcode(!douyinQrcode)
  }
  //  关注楼盘
  const changeFollowHouse = async () => {
    let params = {
      houseId: id,
      followStatus: detailData.followStatus ? 0 : 1
    }
    const res = await followHouse(params)
    if (res.success === true) {
      message.success('操作成功')
      setDetailData({
        ...detailData,
        followStatus: params.followStatus
      })
    }
  }
  //  tab切换
  const changeTabs = key => {
    let path = '/managecenter/house/' + tabsList[key].name + '/' + id
    navigate(path)
    setCount(count + 1)
  }

  useEffect(() => {
    if(!checkMenu(location.pathname.replace('/' + id, ''))) {
      navigate('/managecenter/404')
      return
    }
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    let pathList = getChildPath('/managecenter/house/detail') || []
    let tabs = [
      {
        key: '0',
        label: '概况',
        name: 'detail',
        children: <HouseInfo changeLinkTabs={toLinkTabs} />
      }
    ]

    let key = '0'
    pathList?.forEach((item, index) => {
      //  检查url是否在权限中
      if (!checkMenu(item.path)) {
        return
      }

      let name = item.path.replace('/managecenter/house/', '')
      tabs.push({
        key: index + 1,
        label: item.name,
        name,
        children: pageObj[name]
      })

      params.name === name && (key = index + 1)
    })
    setTabsList(tabs)
    setTabsKey(key)
    getDetail()
  }, [count])
  return (
    <div>
      <Helmet>
        <title>{'楼盘详情-' + process.env.REACT_APP_HTML_TITLE}</title>
      </Helmet>
      <div className="pageTitle">
        <div className="pageTitle-name">{detailData.name}</div>
        <Button size="small" className="pageTitle-btn" onClick={changeFollowHouse}>
          {detailData.followStatus ? '已关注' : '关注'}
        </Button>
        <Button size="small" className="pageTitle-btn" onClick={changeWxQrcode}>
          微信码
        </Button>
        <Button size="small" className="pageTitle-btn" onClick={changeDouyinQrcode}>
          抖音码
        </Button>
      </div>
      <div className="tabs">
        <Tabs activeKey={tabsKey} items={tabsList} onTabClick={changeTabs} />
      </div>
      <Modal footer={null} open={wxQrcode} title="微信码" onCancel={changeWxQrcode} style={{ textAlign: 'center' }}>
        <Image src={detailData.weixinQrcode} width="200px" style={{ padding: '40px 0' }} />
      </Modal>
      <Modal footer={null} open={douyinQrcode} title="抖音码" onCancel={changeDouyinQrcode} style={{ textAlign: 'center' }}>
        <Image src={detailData.douyinQrcode} width="200px" style={{ padding: '40px 0' }} />
      </Modal>
    </div>
  )
}
